import convertHelper from '@/helper/convertHelper';
import placeholder from '@/assets/img/placeholder-image.svg';

const getCanvas = function getCanvas(imgNode, imgData, background) {
	const canvas = document.createElement('canvas');
	canvas.width = imgData.width;
	canvas.height = imgData.height;

	const context = canvas.getContext('2d');

	const imgRatio = imgNode.height / imgNode.width;
	const imgWidth = imgData.width * imgData.scale;
	const imgHeight = imgData.width * imgData.scale * imgRatio;
	const imgRotation = imgData.rotation * (Math.PI / 180);

	const imgLeft = imgData.width * (0.5 + imgData.left);
	const imgTop = imgData.height * (0.5 + imgData.top);

	context.fillStyle = background || imgData.background;
	context.fillRect(0, 0, imgData.width, imgData.height);
	context.translate(imgLeft, imgTop);
	context.rotate(imgRotation);
	context.drawImage(imgNode, imgWidth / -2, imgHeight / -2, imgWidth, imgHeight);
	if (imgData.border) {
		context.lineWidth = 2;
		context.strokeStyle = '#000000';
		context.strokeRect(imgWidth / -2, imgHeight / -2, imgWidth, imgHeight);
	}
	return canvas;
};

const getImage = function getImage(data, callback) {
	// first create placeholder
	const placeholderImgNode = new Image();
	const con = {
		width: parseInt(data.I_Sollbreite, 10) || parseInt(data.base_width, 10) || 500,
		height: parseInt(data.I_Sollhoehe, 10) || parseInt(data.base_height, 10) || 500,
		scale: 1,
		left: 0,
		top: 0,
		rotation: 0,
		background: '#EDECEB',
		border: data.B_Rahmen === 'j',
	};
	const placeholderLoad = new Promise((resolve) => {
		placeholderImgNode.onload = () => {
			const placeholderData = getCanvas(placeholderImgNode, con).toDataURL();
			callback(placeholderData, true);
			resolve(placeholderData);
		};
		placeholderImgNode.src = placeholder;
	});

	placeholderLoad.then((placeholderData) => {
		// then create real file
		const img = new Image();
		img.crossOrigin = 'Anonymous';
		img.onerror = () => {
			 /* TODO: Use (better) logging */
			callback(placeholderData, false);
		};
		img.onload = () => {
			const converted = convertHelper.importData(data, img);
			converted.width = converted.width === 0 ? 500 : converted.width;
			converted.height = converted.height === 0 ? 500 : converted.height;
			const imgFile = getCanvas(img, converted).toDataURL();
			callback(imgFile, false);
		};
		img.src = data.value;
	});
};

export default { getCanvas, getImage };



// WEBPACK FOOTER //
// ./src/helper/renderHelper.js